import React from 'react';
import Icon from "../../Icon";

const currentYear = new Date().getFullYear();
const AskAge = (props) => {

    function listNumbers(start = 0, end = 0) {
        let i;
        let list = [];
        for (i = start; i <= end; i++) {
            list.push({
                value: i < 10 ? `0${i}` : i,
                label: i < 10 ? `0${i}` : i
            });
        }
        return list;
    }

    function listNumbersReverse(start = 0, end = 0) {
        let i;
        let list = [];
        for (i = start; i >= end; --i) {
            list.push({
                value: i,
                label: i
            });
        }
        return list;
    }

    return (
        <div id={"askAge"}>
            <div className={"important-information"}>
                Votre date de naissance est privée et ne sera pas diffusée sur Voissa. Seule une tranche d’âge
                apparaitra (exemple, 18-25 ans au lieu de 21 ans)
            </div>
            <div
                className={`gender-age ${(props.gender === 1 || props.gender === 2 || props.gender === 6) ? 'single' : ''}`}>
                {props.gender === 3 && props.currentQuestion === 0 && (
                    <div className={`gender-title him`}>
                        Lui
                    </div>
                )}
                {((props.gender === 3 && props.currentQuestion === 1) || props.gender === 4) && (
                    <div className={`gender-title her`}>
                        Elle
                    </div>
                )}
                {props.gender === 5 && (
                    <div className={`gender-title him`}>
                        Lui
                    </div>
                )}
                <div className={"age-selection-wrapper"}>
                    <div className={`row full`}>
                        <div className={"date-select"}>
                            <select
                                onChange={(event) => props.handleDate("day", event.target.value, props.currentIndex)}
                                value={props.birthday.day !== undefined ? props.birthday.day : 0}>
                                <option disabled value={0}>jour</option>
                                {listNumbers(1, 31).map((item, index) => (
                                    <option value={item.value} key={index}>{item.label}</option>
                                ))}
                            </select>
                            <Icon type={"arrow-down"}/>
                        </div>
                        <div className={"date-select"}>
                            <select
                                onChange={(event) => props.handleDate("month", event.target.value, props.currentIndex)}
                                value={props.birthday.month !== undefined ? props.birthday.month : 0}>
                                <option disabled value={0}>mois</option>
                                {listNumbers(1, 12).map((item, index) => (
                                    <option value={item.value} key={index}>{item.label}</option>
                                ))}
                            </select>
                            <Icon type={"arrow-down"}/>
                        </div>
                        <div className={"date-select"}>
                            <select
                                onChange={(event) => props.handleDate("year", event.target.value, props.currentIndex)}
                                value={props.birthday.year !== undefined ? props.birthday.year : 0}>
                                <option disabled value={0}>année</option>
                                {listNumbersReverse((currentYear - 18), (currentYear - 120)).map((item, index) => (
                                    <option value={item.value} key={index}>{item.label}</option>
                                ))}
                            </select>
                            <Icon type={"arrow-down"}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AskAge;